export const cleanVersionString = (
	version: string | undefined
): string | undefined => version?.replaceAll('.', '')
